angular.module 'zc.users'

.controller 'AcceptUserInvitationCtrl', (
  $rootScope,
  $scope,
  $state,
  $translate,
  Devise,
  Page,
  afterLoginHandler,
  user,
) ->
  Page.setBodyClass ''

  $translate.use(user.lang)
  $translate('users.controllers.invitation.accept').then (translation) ->
    Page.setTitle translation

  $scope.user = user
  $scope.isAgreeToTosAndPrivacyPolicy = false

  deregistrationCallback = $rootScope.$on('languageSelected', (_, selectedLanguage) ->
    $scope.selectedLanguage = selectedLanguage
    user.lang = selectedLanguage
  )

  $rootScope.$on '$destroy', deregistrationCallback

  $scope.submit = (user) ->
    return if !$scope.isAgreeToTosAndPrivacyPolicy

    Devise.accept(user)
    .then (user) ->
      Devise.signAgreements(user)
    .then (user) ->
      afterLoginHandler.handle(user)



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/controllers/invitation/accept.js.coffee